module.exports = __webpack_public_path__ + "static/img/cy.219e43a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/cy.jpg
// module id = Wh1q
// module chunks = 153